import { useEffect, useMemo, useRef, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useMatch, useNavigate, useParams } from "react-router-dom";
import { IOptionsProps } from "../../../Components/Form/Select/select.component";
import { useToast } from "../../../Hooks/ToasContext";
import { ICategoryEntity } from "../../../Services/api/categories/categories.interface";
import { ICubageVariantAssociated } from "../../../Services/api/cubages-variants/cubages-variants.interface";
import { ICubageEntity } from "../../../Services/api/cubages/cubages.interface";

import { ICreateStockPayload, IStockEntity, STockMovimentationEnum } from "../../../Services/api/stocks/stocks.interface";
import { ListCategoriesUseCase } from "../../../Usecase/Categories/list-categories-usecase";  
import { ListServiceInfoOrdersUseCase } from "../../../Usecase/ServicesInfo/list-service-info-usecase";

import { FindKeyWithPrefix } from "../../../utils/findKeyWithPrefix";
import { CreateStockUseCase } from "../../../Usecase/Stocks/create-stocks-usecase";

import { ShowProductUseCase } from "../../../Usecase/Products/show-product-usecase";
import { ListMangerStocksUseCase } from "../../../Usecase/Stocks/list-manager-stocks-usecase";
import { IProductEntity } from "../../../Services/api/products/products.interface";
import * as Yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup";
import { EStoreType } from "../../../Services/api/orders-replacement/orders-replacement.interface";
import { useAuth } from "../../../Hooks/Auth";


interface IUseCreateStocksProps {
    createStockUseCase: CreateStockUseCase
    listMangerStocksUseCase: ListMangerStocksUseCase
    listServiceInfoOrdersUseCase: ListServiceInfoOrdersUseCase
    listCategoriesUseCase: ListCategoriesUseCase
    showProductUseCase: ShowProductUseCase
}

export interface IStockProps {
    productId: string,
    store: string,
    howMany: number,
    action: string,
    stock: string,
    description: string
}
  

const CreateStockSchemaValidation = Yup.object().shape({
  howMany: Yup.number().required('Quantidade é obrigatório'),
  description: Yup.string().required('Motivo é obrigatório'),
  action: Yup.string().required('Tipo de movimentação é obrigatório'),
  stock: Yup.string().required('Estoque é obrigatório'),
  store: Yup.string().required('Loja é obrigatório'),
});




  const storeTypeOptions = [
    { label: 'EMPO - B2B', value: 'B2B' },
    { label: 'EMPO - B2C', value: 'B2C' },
  ];

  // const operationTypeOptions = [
  //   { label: 'Entrada', value: 'add' },
  //   { label: 'Saída', value: 'remove' },
  //   { label: 'Ajuste (Não irá movimentar no Omie)', value: 'adjust' },
  // ];



  export const movimentationStockName = [
    {
      "value": STockMovimentationEnum.NEW_REQUEST_ORDER,
      "label": "Empenho"
    },
    {
      "value": STockMovimentationEnum.NEW_SERVICE_ORDER,
      "label": "Produção"
    },
    {
      "value": STockMovimentationEnum.PRODUCED,
      "label": "Acabado"
    },
  ];


export function useCreateStocks({ createStockUseCase, listMangerStocksUseCase, listServiceInfoOrdersUseCase, listCategoriesUseCase, showProductUseCase }: IUseCreateStocksProps){
   
    const [loading, setLoading] = useState(false)
    const [images, setImages] = useState<File[]>([]);
    const [showCategoriesModal, setShowCategoriesModal] = useState(false)
    const [categories,setCategories] = useState<ICategoryEntity[]>([])
    const [categoriesSelected,setCategoriesSelected] = useState<ICategoryEntity[]>([])
    const [showSEOModal, setShowSEOModal] = useState(false)
    const [showCubageModal, setShowCubageModal] = useState(false)
    const [showInternalCode, setShowInternalCode] = useState(false)
    const [showVariationsModal, setShowVariationsModal] = useState(false)
    const [internalCode, setInternalCode] = useState<{maskCode: string, internalName: string}>({maskCode: '', internalName: ''})
    const [variations,setVariations] = useState<string[]>([])
    const [cubagesList, setCubagesList] = useState<ICubageEntity[]>([])
    
    const [stocksServicesOptions, setStocksServicesOptions] = useState<IOptionsProps[]>([])
    const [tributaryRegimeOptions, setTributaryRegimeOptions] = useState<IOptionsProps[]>()
    const [lcCode, setLcCode] = useState<IOptionsProps[]>()
    const [nbsCode, setNbsCode] = useState<IOptionsProps[]>()
    const [data, setData] = useState<IStockEntity>()
    const [cubagesSelected, setCubagesSelected] = useState<ICubageVariantAssociated[]>([])
    const [product, setProduct] = useState<IProductEntity>()
    const { user } = useAuth()

    const operationTypeOptions =  useMemo(() => {
      const hasCancelPermission =  user?.permissionsScreens?.includes(`stocks:adjust-manually:manage`)
  
      const options = [
        { label: 'Entrada', value: 'add' },
        { label: 'Saída', value: 'remove' },
      ]
  
      if(hasCancelPermission){
        options.push({ label: 'Ajuste (Não irá movimentar no Omie)', value: 'adjust' })
      }
  
      return options
    }, [user])
  
    

    const params = useParams()
    
    const navigate = useNavigate()

    const { handleSubmit, register, control, formState, watch, setValue, unregister, getValues } = useForm<IStockProps>({
        resolver: yupResolver(CreateStockSchemaValidation),
      
      });



      const { errors } =  formState

   

    const { showToast } =  useToast()

    const dragAndDropRef = useRef<any>(null);

    const handleAction: SubmitHandler<IStockProps> = async (values) => {
  
    try {
        setLoading(true)
       
        console.log("values: ", values)

        const payload : ICreateStockPayload = {
          productId: String(params.productId),
          store: values.store as EStoreType,
          howMany: values.howMany,
          action: values.action as "add" | "remove" | "adjust",
          description: values.description
        } 

        if(values.action === 'add'){
          payload.toStock = values.stock as STockMovimentationEnum
          // const stockLabel = movimentationStockName.find(item => item.value === values.stock)?.label
          // payload.description = `Adicionando produto ao estoque ${stockLabel}`
        } else if(values.action === 'remove'){
          payload.fromStock = values.stock as STockMovimentationEnum
          // const stockLabel = movimentationStockName.find(item => item.value === values.stock)?.label
          // payload.description = `Removendo produto do estoque ${stockLabel}`
        } else if(values.action === 'adjust'){
          payload.toStock = values.stock as STockMovimentationEnum
        }

        console.log("payload: ", payload)

        const storeResult = await createStockUseCase.handle(payload)

        if (storeResult.isFailure) {
        
        showToast(String(storeResult?.error?.error), 'error');
        return;
        }

        showToast('Movimentação de estoque realizada com sucesso', 'success');
        
    
        navigate(`/stocks-details/${String(params.productId)}`);
    } catch (error) {
      console.log("error: ", error)
        // toast({
        //   position: 'top-right',
        //   render: () => <ToastCustom type='fail' title='Erro' description={error.response?.data?.error ?? 'Erro ao logar. Por favor, tente novamente'} />,
        // });
    } finally {
        setLoading(false);
    }
    };

    const handleSelectCategories = (e: ICategoryEntity) => {
    const existsCategory = categoriesSelected.find(category => category.id === e.id)

    if(existsCategory){
        const filtered = categoriesSelected?.filter(category => category.id !== e.id)
        setCategoriesSelected([...filtered])
    } else {
        setCategoriesSelected(prev => [...prev, e])
    }
    }

    const handleShowProduct = async (stockId: string) => {
        
      try {
        setLoading(true)
        
        const showResult = await showProductUseCase.handle(stockId);

        if (showResult.isFailure) {
          showToast(String(showResult?.error?.error), 'error');
          return;
        }

       const p = showResult.getValue()

       if(p){
        setProduct(p)
       }

      } catch (error) {
        console.log("error handleShowStock function: ", error)
      } finally {
        setLoading(false);
      }
    };

   
    const listCategories = async () => {
        
      try {
        setLoading(true)
        
        const listResult = await listCategoriesUseCase.handle({page: 1, getAll: true});

        if (listResult.isFailure) {
     
          showToast(String(listResult?.error?.error), 'error');
          return;
        }

       const list = listResult.getValue()

       if(list){
          setCategories(list.data)
          
       }

  
    
      } catch (error) {
        console.log("error listCategories function: ", error)
      } finally {
        setLoading(false);
      }
    };

   
    useEffect(() => {
      if(params.productId){
        handleShowProduct(params.productId)
      }
    },[params])


      

    return {
        loading,
        handleSubmit,
        handleAction,
        register,
        errors,
        control,
        handleSelectCategories,
   
        showCategoriesModal,
        setShowCategoriesModal,
        showSEOModal,
        setShowSEOModal,
        showCubageModal,
        setShowCubageModal,
        showInternalCode,
        setShowInternalCode,
        showVariationsModal,
        setShowVariationsModal,
        internalCode,
        setInternalCode,
        variations,
        setVariations,
        images,
        setImages,
        cubagesList,
     
        categories,
        setCategories,
        dragAndDropRef,
    
       
        stocksServicesOptions,
        cubagesSelected,
        
        storeTypeOptions,

        listCategories,
        categoriesSelected,
        data,
        operationTypeOptions,
        product,
        movimentationStockName
        
        
    }
}